import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import Str from "shared/components/Str";

import {
	CREDIT_SCREEN,
	PAYPAL_SCREEN,
} from "shared/payment/constants";

import "./Navigation.scss";

const Navigation = ({
	currentScreen,
	onChangeScreen,
}) => {
	const isCreditScreen = CREDIT_SCREEN === currentScreen;
	const isPaypalScreen = PAYPAL_SCREEN === currentScreen;

	return (
		<div
			className={classnames({
				"payment-navigation": true,
			})}
		>
			<div
				className={classnames({
					"payment-navigation-indicator": true,
					"payment-navigation-indicator--paypal": isPaypalScreen,
				})}
			/>
			<button
				className={classnames({
					"payment-navigation-button": true,
					"payment-navigation-button-credit": true,
					"payment-navigation-button-credit--selected": isCreditScreen,
				})}
				onClick={() => onChangeScreen(CREDIT_SCREEN)}
			>
				<Str>Credit/Debit</Str>
			</button>

			<button
				className={classnames({
					"payment-navigation-button": true,
					"payment-navigation-button-paypal": true,
					"payment-navigation-button-paypal--selected": isPaypalScreen,
				})}
				onClick={() => onChangeScreen(PAYPAL_SCREEN)}
			>
				<Str>PayPal</Str>
			</button>
		</div>
	);
};

Navigation.propTypes = {
	currentScreen: PropTypes.string.isRequired,
	onChangeScreen: PropTypes.func.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Navigation/index.jsx